// ============================================================================
// English Translations - Re-export from JSON
// ============================================================================
import enJson from './en.json';
// Export the English translations with proper typing
export const en = enJson;
//# sourceMappingURL=en.js.map